module.exports = __webpack_public_path__ + "static/media/abhilash.9613a779.jpg";